import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class NetPositionsUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getNetPositions();
    }
}
export default NetPositionsUseCase;
